<script>

import FileApi from '@/api/common/file';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import moment from 'moment';

import WDeviceRegularCheckView from '@/views/config/group/netdevice/components/DeviceRegularCheckView';
import MapAPI from '@/api/topologymap/common';

export default {
  name: 'WTopologymapDeviceRegularCheckView',
  extends: WDeviceRegularCheckView,
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    loadCheckList() {
      if (!isNil(this.selectedCheckDate)) {
        const checkDatetime = moment(this.selectedCheckMonth).date(this.selectedCheckDate).toDate();
        const tableParams = this.$refs.tempTable.getParameter();
        const params = {
          checkDatetime: checkDatetime.getTime(),
          ...tableParams,
          mapId: this.$store.getters.getCurrentMapId,
        };
        this.loading = true;
        MapAPI.getNetdeviceRegularCheckList(params).then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            if (isEmpty(result)) {
              this.tableData = [];
              this.tableTotal = 0;
              this.checkCountData = 0;
            } else {
              this.tableData = result.list.data;
              this.tableTotal = result.list.total;
              this.checkCountData = result.count;
            }
          } else {
            this.showLoadFailMsg();
          }
        }).catch(() => {
          this.showLoadFailMsg();
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    loadDays() {
      const params = {
        managegroupIds: this.managegroupIds,
        mapId: this.$store.getters.getCurrentMapId,
        startDatetime: this.selectedCheckMonth.getTime(),
      };
      MapAPI
        .getNetdeviceRegularCheckDayList(params).then((response) => {
          if (response.data.success) {
            if (response.data.data.length > 0) {
              this.checkDateList = response.data.data;
              if (this.checkDateList[0].DAY === this.selectedCheckDate) {
                this.loadCheckList();
              } else {
                this.selectedCheckDate = this.checkDateList[0].DAY;
              }
            } else {
              this.checkDateList = [];
              this.selectedCheckDate = null;
              this.checkCountData = null;
              this.tableData = [];
            }
          } else {
            this.showLoadFailMsg();
          }
        }).catch(() => {
          this.showLoadFailMsg();
        });
    },
    exportExcel() {
      const checkDatetime = moment(this.selectedCheckMonth).date(this.selectedCheckDate).toDate();
      const tableParams = this.$refs.tempTable.getParameter();
      const params = {
        ...tableParams,
        checkDatetime: checkDatetime.getTime(),
        mapId: this.$store.getters.getCurrentMapId,
      };
      MapAPI.getNetdeviceRegularCheckListExcelName(params).then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          FileApi.downloadExportedExcelFile(response.data.data);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/perfoper/config/components/netdevice/TopologymapDeviceRegularCheckView.vue